function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "4C65BEF1-7FE0-40CC-991D-38CBF879DC66@2x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.300000012
}, /*#__PURE__*/React.createElement("g", {
  id: "cadastrar-ong",
  transform: "translate(-345.000000, -243.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(307.000000, 200.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(40.000000, 45.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.2742977,4.72521828 C14.8587603,2.02387411 17.262328,5.28362019e-16 20.1385969,0 L31.3528826,0 C34.2291514,-5.28362019e-16 36.6327192,2.02387411 37.2171817,4.72521828 L44,4.72521828 C47.3137085,4.72521828 50,7.41150979 50,10.7252183 L50,34.6779661 C50,37.9916746 47.3137085,40.6779661 44,40.6779661 L6,40.6779661 C2.6862915,40.6779661 1.87739444e-15,37.9916746 0,34.6779661 L0,10.7252183 C-4.05812251e-16,7.41150979 2.6862915,4.72521828 6,4.72521828 L14.2742977,4.72521828 Z",
  id: "Combined-Shape",
  stroke: "#8798AD",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#8798AD",
  cx: 43.220339,
  cy: 11.8644068,
  r: 2.54237288
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  stroke: "#8798AD",
  strokeWidth: 3,
  fill: "#FFFFFF",
  cx: 25,
  cy: 22.4576271,
  rx: 9.74576271,
  ry: 9.3220339
})))));

var SvgPhotoCamera = function SvgPhotoCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "45px",
    viewBox: "0 0 54 45",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhotoCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo-camera.343478fe.svg";
export { ForwardRef as ReactComponent };